// @flow
import React, { memo } from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import { TableRow, TableRowColumn } from 'material-ui/Table';
import { withRouter } from 'react-router-dom';

const UserListItem = memo(({ history, user: { id, name, email, blocked, active, canDelete } }) => {
	const renderBoolean = value => (value ? 'Да' : 'Нет');
	return (
		<TableRow onClick={() => history.push(`/users/${id}`)}>
			<TableRowColumn>{name}</TableRowColumn>
			<TableRowColumn>{email}</TableRowColumn>
			<TableRowColumn>{renderBoolean(blocked)}</TableRowColumn>
			<TableRowColumn>{renderBoolean(active)}</TableRowColumn>
			<TableRowColumn>{renderBoolean(canDelete)}</TableRowColumn>
		</TableRow>
	);
});

export default withRouter(
	createFragmentContainer(
		UserListItem,
		{
			user: graphql`
                fragment UserListItem_user on User {
                    id
                    name
                    email
                    active
                    canDelete
                    blocked
                    testText
                }
			`
		}
	),
);



// WEBPACK FOOTER //
// src/components/users/UserListItem.js